import { Navigate, RouteObject } from "react-router-dom";

import App from "./App";
import { OrderContextProvider } from "./contexts/OrderContext";
import { RoutePath } from "./models/routePath";
import BookTimeSlot from "./pages/bookTimeSlot/BookTimeSlot";
import ConfirmDeliveryDate from "./pages/confirmDeliveryDate/ConfirmDeliveryDate";
import ConfirmQuantities from "./pages/confirmQuantities/ConfirmQuantities";
import Dashboard from "./pages/dashboard/Dashboard";
import DeliveriesOverview from "./pages/deliveriesOverview/DeliveriesOverview";
import DeliveryDetails from "./pages/deliveryDetails/DeliveryDetails";
import EditOrder, { editOrderSteps } from "./pages/editOrder/EditOrder";
import NewOrder, { newOrderSteps } from "./pages/newOrder/NewOrder";
import NewOutboundDelivery, {
  newOutboundDeliverySteps,
} from "./pages/newOutboundDelivery/NewOutboundDelivery";
import OutboundDeliveriesOverview from "./pages/outboundDeliveriesOverview/OutboundDeliveriesOverview";
import SplitOrder from "./pages/splitOrder/SplitOrder";
import StockOverview from "./pages/stockOverview/StockOverview";

// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Protected routes
/* const DeliveriesOverview = AsyncComponent(
  () => import("./pages/deliveriesOverview/DeliveriesOverview"),
); */
//const NewOrder = AsyncComponent(() => import("./pages/newOrder/NewOrder"));

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      // we need to redirect to the home route from the default route, becaue the RouterPrompt does not notice a change from for example "/newOrder" to "/".
      {
        path: "/",
        element: <Navigate to={RoutePath.Home} />,
      },
      {
        path: RoutePath.Home,
        element: <Dashboard />,
      },
      {
        path: RoutePath.InboundDeliveries,
        element: <DeliveriesOverview />,
      },
      {
        path: RoutePath.OutboundDeliveries,
        element: <OutboundDeliveriesOverview />,
      },
      {
        path: RoutePath.NewOutboundDelivery,
        element: (
          <OrderContextProvider
            key="newOutboundDelivery"
            initialSteps={newOutboundDeliverySteps}
            initialProgressLevel={1}
          >
            <NewOutboundDelivery />
          </OrderContextProvider>
        ),
      },
      {
        path: RoutePath.Stocks,
        element: <StockOverview />,
      },
      {
        path: RoutePath.InboundDelivery + "/:id",
        element: <DeliveryDetails />,
      },
      {
        path: RoutePath.NewOrder,
        element: (
          <OrderContextProvider
            key="newOrder"
            initialSteps={newOrderSteps}
            initialProgressLevel={1}
          >
            <NewOrder />
          </OrderContextProvider>
        ),
      },
      {
        path: RoutePath.EditOrder + "/:id",
        element: (
          <OrderContextProvider
            key="editOrder"
            initialSteps={editOrderSteps}
            initialProgressLevel={5}
          >
            <EditOrder />
          </OrderContextProvider>
        ),
      },
      {
        path: RoutePath.SplitOrder + "/:id",
        element: <SplitOrder />,
      },
      {
        path: RoutePath.ConfirmQuantities + "/:id",
        element: (
          <OrderContextProvider
            key="confirmQuantities"
            //the following is irrelevant here, we just use partial functionality of this context
            initialSteps={newOrderSteps}
            initialProgressLevel={1}
          >
            <ConfirmQuantities />
          </OrderContextProvider>
        ),
      },
      {
        path: RoutePath.ConfirmDeliveryDate + "/:id",
        element: <ConfirmDeliveryDate />,
      },
      {
        path: RoutePath.BookTimeSlot + "/:id",
        element: <BookTimeSlot />,
      },
    ],
  },
];

export default routes;
